import { StudioState } from '../../types/store';
import { GallerySettingsState } from '../../types/gallerySettings';
import {
  loadSettingsSuccess,
  loadSettingsFailure,
  loadGalleriesSuccess,
  loadGalleriesFailure,
  saveSettingsSuccess,
  saveSettingsFailure,
} from '../../actions/studio/gallerySettings';

const defaultGallerySettings: GallerySettingsState = {
  settings: null,
  isLoading: false,
  error: null,
  isSaving: false,
  saveError: null,
  galleries: [],
};

const updateGallerySettings = (
  state: StudioState,
  updates: Partial<GallerySettingsState>
): StudioState => ({
  ...state,
  gallerySettings: {
    ...defaultGallerySettings,
    ...state.gallerySettings,
    ...updates,
  },
});

export const handleLoadSettings = (state: StudioState): StudioState =>
  updateGallerySettings(state, { isLoading: true, error: null });

export const handleLoadSettingsSuccess = (
  state: StudioState,
  action: ReturnType<typeof loadSettingsSuccess>
): StudioState =>
  updateGallerySettings(state, {
    settings: action.payload.settings,
    isLoading: false,
    error: null,
  });

export const handleLoadSettingsFailure = (
  state: StudioState,
  action: ReturnType<typeof loadSettingsFailure>
): StudioState =>
  updateGallerySettings(state, { isLoading: false, error: action.payload.error });

export const handleLoadGalleries = (state: StudioState): StudioState =>
  updateGallerySettings(state, { isLoading: true });

export const handleLoadGalleriesSuccess = (
  state: StudioState,
  action: ReturnType<typeof loadGalleriesSuccess>
): StudioState =>
  updateGallerySettings(state, { galleries: action.payload.galleries, isLoading: false });

export const handleLoadGalleriesFailure = (
  state: StudioState,
  action: ReturnType<typeof loadGalleriesFailure>
): StudioState =>
  updateGallerySettings(state, { isLoading: false, error: action.payload.error });

export const handleSaveSettings = (state: StudioState): StudioState =>
  updateGallerySettings(state, { isSaving: true, saveError: null });

export const handleSaveSettingsSuccess = (
  state: StudioState,
  action: ReturnType<typeof saveSettingsSuccess>
): StudioState =>
  updateGallerySettings(state, {
    settings: action.payload.settings,
    isSaving: false,
    saveError: null,
  });

export const handleSaveSettingsFailure = (
  state: StudioState,
  action: ReturnType<typeof saveSettingsFailure>
): StudioState =>
  updateGallerySettings(state, { isSaving: false, saveError: action.payload.error });

export const handleResetState = (state: StudioState): StudioState => ({
  ...state,
  gallerySettings: defaultGallerySettings,
});
